





























































import { Vue, Component, Prop } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

@Component({})
export default class ProgramSearchComponent extends Vue {
  @Prop({ default: 'Rechercher...' }) placeholder!: string;
  @Prop({ required: true }) fetch!: (value: string) => Promise<Array<{ value: any; text: string }>>;

  selectedId: number | null = null;
  searching = false;
  hasSearched = false;
  programs: any[] = [];
  fetchSeq = 0;
  debouncedFetch = debounce(this.doFetch, 350);

  onSearch(value: string) {
    this.debouncedFetch(value);
  }

  async doFetch(value: string) {
    const isNumeric = /^\d+$/.test(value || '');
    const minLen = isNumeric ? 1 : 3;
    if (!value || value.length < minLen) {
      this.programs = [];
      this.searching = false;
      return;
    }
    const seq = ++this.fetchSeq;
    this.searching = true;
    try {
      const results = await this.fetch(value);
      if (seq !== this.fetchSeq) return; // stale response — a newer request is in flight
      this.programs = results.map(r => r.value).filter(Boolean);
      this.hasSearched = true;
    } finally {
      if (seq === this.fetchSeq) {
        this.searching = false;
      }
    }
  }

  onChange(id: number | null | undefined) {
    if (id == null) {
      this.$emit('change', null);
      return;
    }
    const prog = this.programs.find(p => p.id === id);
    this.$emit('change', prog || null);
  }

  labelFor(prog: any): string {
    const icon = prog.status === 'sold' ? '✗' : '✓';
    return `${icon} #${prog.id} — ${prog.name}`;
  }

  clear() {
    this.selectedId = null;
    this.programs = [];
    this.hasSearched = false;
    this.searching = false;
    this.$emit('change', null);
  }

  /** Show a program as selected — does NOT emit change or touch filters. */
  setSelected(prog: any) {
    if (!prog) {
      this.resetUI();
      return;
    }
    this.programs = [prog];
    this.selectedId = prog.id;
  }

  /** Reset visual state only — does NOT emit change or touch filters. */
  resetUI() {
    this.selectedId = null;
    this.programs = [];
    this.hasSearched = false;
    this.searching = false;
  }
}
